import { jsx } from "react/jsx-runtime";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { validateTidalLicense } from "../../base/index.js";
function CheckCircleOutline(props) {
  return /* @__PURE__ */ jsx(
    CheckCircleOutlineIcon,
    {
      "data-testid": "CheckCircleOutline",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CheckCircleOutline",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
CheckCircleOutline.tidalIconMeta = {
  categories: "cancel,informative",
  name: "CheckCircleOutline"
};
validateTidalLicense();
export {
  CheckCircleOutline
};
//# sourceMappingURL=CheckCircleOutline.js.map
